import ListingsRoutingResolver from './ListingRoutingResolver';

class PipelineListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "pipeline"
    }

    getDefaultFunnel() {
        /**
         * default funnel
         * 
         * @returns {Promise}
         */
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.post(`/prospection/funnel/default`, {}, { init: true }, (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    }
}

export default PipelineListingResolver
